import { defineMessages } from 'react-intl-next';

export default defineMessages({
	iconLabel: {
		id: 'rovo-chat.message-file.icon-label',
		defaultMessage: 'File',
		description: 'Label for the file icon',
	},
} as const);
